import { useAuth0 } from "@auth0/auth0-react";
import { Avatar } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import BreadCrumbs from "components/Breadcrumbs";
import AlertDialog from "components/Dialog";
import MyButton from "components/MyButton";
import AuthService from "Lib/API/Auth";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import ProfileCompletion from "../MembersDrawer/ProfileCompletion";
import AddNewTag from "./AddNewTag";
import "./style.scss";
import { fontConfig } from "theme/fontConfig";

const UserDetailsHeader = ({
  setSelected,
  user,
  account,
  setRefresh,
  refresh,
}) => {
  const [selectedTag, setSelectedTag] = useState([]);
  const [deleteTagConfirm, setDeleteTagConfirm] = useState(false);
  const [tagToDelete, setTagToDelete] = useState(null);
  const [openTag, setOpenTag] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [load, setLoad] = useState(false);
  const history = useHistory();

  const links = [
    <Link
      key="1"
      color="#666667"
      onClick={() => history.push("/members")}
      fontSize={14}
      underline="hover"
    >
      Members
    </Link>,
    <Link
      underline="hover"
      fontSize={14}
      key="2"
      color="#666667"
      onClick={() => {
        setSelected("Family");
        history.push(`/member-details/${user?.account_id}`);
      }}
    >
      {account?.family_name}
    </Link>,
    <Link underline="hover" fontSize={14} key="3" color="#aeadad">
      {`${user.first_name} ${user.last_name}`}
    </Link>,
  ];
  const calculateProfileCompletion = (user) => {
    const {
      account,
      createdAt,
      id,
      member_id,
      profile_img,
      relationship,
      _id,
      profile_completion,
      backGround,
      account_id,
      organization,
      updatedAt,
      __v,
      ...data
    } = { ...(user ? user : {}) };
    const insertedValues = Object.values(data);
    const insertedValuesLng = insertedValues.filter((it) => {
      if (it !== "") {
        if (typeof it === "object") {
          if (it?.formattedAddress !== undefined) {
            return true;
          } else return false;
        }
        return true;
      } else return false;
    })?.length;
    return Math.round((insertedValuesLng / 23) * 100) > 100
      ? 100
      : Math.round((insertedValuesLng / 23) * 100);
  };

  const deleteTag = async (tag) => {
    const token = await getAccessTokenSilently();
    AuthService.deleteContactTag({ contactId: user?._id, tag }, token)
      .then((res) => {
        setSelectedTag(selectedTag.filter((item) => item !== tag));
        setLoad(!load);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      });
  };
  useEffect(() => {
    get_contact(user?._id);
  }, [load]);

  const get_contact = async (id) => {
    const token = await getAccessTokenSilently();
    await AuthService.getContactById(id, token)
      .then((res) => {
        setSelectedTag(
          res[0]?.tags?.sort((a, b) =>
            a?.toLowerCase().localeCompare(b?.toLowerCase())
          )
        );
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      });
  };

  return (
    <div className="details-header">
      {/* <div className="navigator">{`Members > ${account?.family_name} > ${user.first_name} ${user.last_name}`}</div> */}
      <div className="navigator">
        <BreadCrumbs links={links} />
      </div>
      <div className="header-content">
        <div className="left-side">
          <div className="lef-content">
            <div className="avatar">
              <Avatar
                alt={user?.first_name}
                src={user?.profile_img}
                style={{ marginRight: "10px", height: "50px", width: "50px" }}
              />
            </div>
            <div className="details">
              <div className="name">
                {`${user.title ? user.title : ""} ${user.first_name} ${
                  user.last_name
                }`}
                {user?.mark_as_deceased && (
                  <span
                    style={{
                      fontSize: "24px",
                      fontWeight: "800",
                    }}
                  >
                    -DECEASED
                  </span>
                )}
              </div>
              <div className="account-id py-2">#{user?.member_id}</div>
              <div className="account-types">
                <div className="user-type px-3">
                  {user?.account_permission !== "admin"
                    ? "Family member"
                    : "Admin"}
                </div>
                {account?.payment?.account_type && (
                  <div className="account-type mx-2 px-3 text-capitalize">
                    {account?.payment?.account_type}
                  </div>
                )}
                {account?.payment?.account_sub_type?.title && (
                  <div className="sub-type px-3">
                    {account?.payment?.account_sub_type?.title}
                  </div>
                )}
                {account?.payment?.product_id && (
                  <div className="billing-type mx-2 px-3">
                    {account?.payment?.product_id?.prod_name}
                  </div>
                )}
                {selectedTag?.length > 0 ? (
                  <div className="tags">
                    {selectedTag?.map((tag, i) => {
                      return (
                        <span className="tag" key={i}>
                          {tag}
                          <span
                            style={{
                              marginLeft: "5px",
                              fontSize: "12px",
                              fontWeight: "400",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setTagToDelete(tag);
                              setDeleteTagConfirm(true);
                            }}
                          >
                            x
                          </span>
                        </span>
                      );
                    })}
                    <div className="add_tag">
                      <span
                        style={{
                          color: "#2555EF",
                          fontFamily: fontConfig.MemberDetailsUserDetailsHeaderTextFont.family,
                          fontWeight: "500",
                          fontSize: "13px",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => setOpenTag(true)}
                      >
                        +
                      </span>
                    </div>
                  </div>
                ) : (
                  <span
                    style={{
                      color: "#2555EF",
                      fontFamily: fontConfig.MemberDetailsUserDetailsHeaderTextFont.family,
                      fontWeight: "500",
                      fontSize: "13px",
                      textAlign: "center",
                      cursor: "pointer",
                      marginLeft: "10px",
                    }}
                    onClick={() => setOpenTag(true)}
                  >
                    +
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="right-side">
          <ProfileCompletion profile={calculateProfileCompletion(user)} />
          <div className="message">
            <MyButton disabled content="Message me" />
          </div>
        </div>
      </div>
      <div className="tag_modal">
        <Dialog
          open={openTag}
          onClose={() => {
            setOpenTag(false);
            setLoad(!load);
          }}
          PaperProps={{
            style: {
              background: "#fff",
              borderRadius: "10px",
            },
          }}
        >
          <AddNewTag
            setOpenTag={setOpenTag}
            openTag={openTag}
            user={user}
            setRefresh={setRefresh}
            refresh={refresh}
            selectedUserTag={selectedTag}
            setLoad={setLoad}
            load={load}
          />
        </Dialog>
        <AlertDialog
          open={deleteTagConfirm}
          onDecline={() => {
            setDeleteTagConfirm(false);
          }}
          onAccept={() => {
            deleteTag(tagToDelete);
            setDeleteTagConfirm(false);
          }}
          title={"Are you sure?"}
          description={`Do you want to delete this tag?`}
        />
      </div>
    </div>
  );
};
export default UserDetailsHeader;
